import React from "react";
import { Box, DialogTitle, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

// Dialog chrome shared by every Trust Center dialog, copied from Risk's
// Add Risk dialog: bold 16px title on the card-header grey, a close button,
// bordered content and a grey action bar.
// The subtitle and close button sit outside DialogTitle so the dialog's
// accessible name stays just the title.
export const DialogHeader = ({ title, subtitle, onClose }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "relative",
        background: theme.customColors.background.cardHeader,
        borderBottom: `1px solid ${theme.customColors.border.main}`,
        px: 3,
        py: 2,
        pr: onClose ? 7 : 3,
      }}
    >
      <DialogTitle
        sx={{
          p: 0,
          // Bold like Risk's dialogs in the app; the public page (its own
          // theme, theme.trust) keeps its lighter headings.
          fontWeight: theme.trust ? 600 : 700,
          fontSize: "16px",
          color: theme.customColors.text.strong,
        }}
      >
        {title}
      </DialogTitle>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{ color: theme.customColors.text.secondary, mt: 0.5 }}
        >
          {subtitle}
        </Typography>
      )}
      {onClose && (
        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: theme.customColors.text.secondary,
            "&:hover": {
              backgroundColor: theme.customColors.background.hover,
              color: theme.customColors.text.strong,
            },
          }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      )}
    </Box>
  );
};

export const dialogPaperProps = { sx: { borderRadius: "12px" } };

export const dialogActionsSx = (theme) => ({
  px: 3,
  py: 1.5,
  gap: 1,
  background: theme.customColors.background.cardHeader,
  borderTop: `1px solid ${theme.customColors.border.main}`,
});
